import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { hasPermissionsGuard } from '@guards/has-permissions.guard';
import { UserListPage } from './list/list.component';
import { UserCreatePage } from './create/create.component';
import { UserUpdatePage } from './update/update.component';
import { UserSettingsPage } from './settings/settings.component';
import { hasRoleGuard } from '@guards/has-role.guard';

let moduleName = 'user';

export const user: Routes = [
  {
    path: moduleName,
    component: UserListPage,
    title: 'Lista de usuarios',
    canActivate: [authGuard, hasPermissionsGuard(['user_create'])],
  },
  {
    path: `${moduleName}/create`,
    component: UserCreatePage,
    title: 'Crear usuario',
    canActivate: [authGuard, hasPermissionsGuard(['user_create'])],
  },
  {
    path: `${moduleName}/details/:slug`,
    component: UserUpdatePage,
    title: 'Actualizar usuario',
    canActivate: [authGuard, hasPermissionsGuard(['user_create'])],
  },
  {
    path: `${moduleName}/settings`,
    component: UserSettingsPage,
    title: 'Configuraciones de usuario',
    canActivate: [authGuard, hasRoleGuard(['SUPERUSER', 'COLABORADOR']), hasPermissionsGuard(['user_create'])],
  },
];
